
import { IFilterState } from '@/store/contract';
import { Component, Vue } from 'vue-property-decorator';
import { Mutation, State, namespace } from 'vuex-class';

const filterModule = namespace('filter');

@Component
export default class AllFiltersButton extends Vue {
    @filterModule.Mutation('toggleModal')
    toggleModal: () => void;

    @State('filter')
    filterState: IFilterState;
}
